<template>
  <v-autocomplete
    v-model="serviceCenter"
    :items="serviceCenterOptions"
    :loading="isLoading"
    :search-input.sync="search"
    @focus="searching"
    @resetLocation="resetLocation"
    hide-no-data
    auto-select-first
    :item-text="(item) => item.Name"
    item-value="CenterNo"
    :label="label"
    :prepend-icon="mdiDatabaseSearch"
    return-object
    no-filter
    :error-messages="errorMessages"
    :itemref="itemref"
    clearable
    v-on:click:clear="clear"
    hide-details
    dense
    :inputmode="inputmode"
    :disabled="disabled"
  >
    <template v-slot:item="{ item }">
      <v-list-item-avatar
        color="secondary"
        class="text-h5 font-weight-light white--text"
      >
        {{ item.Name.charAt(0) }}
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-text="item.Name"></v-list-item-title>
        <v-list-item-subtitle v-text="item.Address"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { mdiDatabaseSearch } from "@mdi/js";
import isObject from "lodash/isObject";
import isEmpty from 'lodash/isEmpty'
import { SelectServiceCenter, GetDefaultPickup } from "@/api/publicServices";
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    cachedServiceCenters: {
      type: Array,
    },
    errorMessages: {
      type: String,
    },
    onChange: {
      type: Function,
    },
    itemref: {
      type: String,
      required: true,
    },
    zoneName: {
      type: String,
    },
    city: {
      type: Object,
    },
    disabled: {
      type:Boolean
    }
  },
  data: () => ({
    serviceCenterOptions: [
      {
        CenterNo: "",
        Name: "",
      },
    ],
    isLoading: false,
    search: null,
    serviceCenter: {
      CenterNo: "",
      Name: "",
    },
    isClear: false,

    //svg icons
    mdiDatabaseSearch,
  }),
  computed:{
    inputmode() {
      return  localStorage.getItem("flutter") == "true" || this.$isMobile()?"none":"text";
    },
  },
  methods: {
    async searchServiceCenter(searchVal) {
      try {
        console.log("searchServiceCenter1");
        if (this.isClear) {
          this.isClear = false;
          return;
        }
        console.log("searchServiceCenter2");
        if (this.isLoading) return;
        console.log("searchServiceCenter3", this.serviceCenter);
        if (!isEmpty(this.serviceCenter) && this.serviceCenter?.Name.length>0 && this.serviceCenter?.Name === searchVal) return;
        console.log("searchServiceCenter4");
        let searchOption = {
          CenterType: this.itemref,
          SearchVal: searchVal,
          ZoneName: this.zoneName,
        };
        let CityCodes = [];
        // for (let index in this.city) {
        //   CityCodes.push(this.city[index].CityCode);
        // }

        if (isObject(this.city) && "CityCode" in this.city)
          CityCodes.push(this.city.CityCode);
        searchOption.CityCodes = CityCodes;

        console.log("zoneName", this.zoneName);
        console.log(searchOption);
        this.isLoading = true;
        const response = await SelectServiceCenter(searchOption);
        console.log(`response:${response}`);
        this.serviceCenterOptions = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async setDefault() {
      try {
        const response = await GetDefaultPickup({});
        this.isLoading = false;
        console.log(response.data);
        if (response.data) {
          this.serviceCenterOptions.push(response.data);
          this.serviceCenter = {
            CenterNo: response.data.CenterNo,
            Name: response.data.Name,
            Address: response.data.Address,
          };
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async searching(t1) {
      this.searchServiceCenter(t1.target.value);
    },
    resetLocation() {
      this.serviceCenter = {};
      this.serviceCenter.CenterNo = "";
      this.serviceCenter.Name = "";
    },
    clear() {
      this.isClear = true;
      console.log("isClear");
    },
  },
  watch: {
    search(newVal) {
      this.searchServiceCenter(newVal);
    },
    serviceCenter() {
      this.$emit("input", this.serviceCenter);
      if (this.$refs.SpotAddress && this.serviceCenter != null) {
        this.$refs.SpotAddress = this.serviceCenter.Address;
      }
    },
  },
};
</script>
